import React, { useEffect, useState } from 'react';
import { Card } from '@heroui/react'; // Assurez-vous que ReactUI est installé et configuré
import {Sun, Cloud, CloudRain, CloudIcon, TriangleAlertIcon} from 'lucide-react'; // Assurez-vous que lucide-react est installé
import { motion } from 'framer-motion';
import Loading from "../../components/loading";
import ErrorPage from './../../components/error';

const WeatherCard = () => {

    const [coords, setCoords] = useState(null);
    const [weatherData, setWeatherData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Récupération de la position géographique du client
    useEffect(() => {

        if (navigator.geolocation) {

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setCoords({
                        lat: position.coords.latitude,
                        lon: position.coords.longitude
                    });
                },
                (err) => {
                    setError("Impossible d'obtenir votre localisation.");
                    setLoading(false);
                }
            );

        } else {

            setError("La géolocalisation n'est pas supportée par votre navigateur.");
            setLoading(false);
        }

    }, []);

    // Une fois les coordonnées récupérées, interroger l'API météo
    useEffect(() => {

        if (coords) {
            
            const fetchWeather = async () => {
                try {
                    const response = await fetch(
                        `https://api.openweathermap.org/data/2.5/weather?lat=${coords.lat}&lon=${coords.lon}&APPID=9278296dc6a78a20d7fb0d797273473f&units=metric`
                    );
                    if (!response.ok) {
                        throw new Error("Erreur lors de la récupération des données météo");
                    }
                    const data = await response.json();
                    setWeatherData(data);

                } catch (err) {
                    setError(err.message);
                } finally {
                    setLoading(false);
                }
            };
            fetchWeather();
        }
    }, [coords]);


            
    if (loading) return (<div className="flex flex-col items-center h-[30vh] bg-white shadow-md rounded-lg dark:bg-zinc-900"><Loading icon={<CloudIcon className='text-primary'/>}/></div>);
    if (error) return (<div className="flex flex-col items-center h-[30vh] bg-white shadow-md rounded-lg dark:bg-zinc-900"><ErrorPage icon={<TriangleAlertIcon className='text-red-500'/>}/></div>);

    // Extraction des données météo
    const temperature = Math.round(weatherData.main.temp);
    const weatherDescription = weatherData.weather[0].description;
    const condition = weatherData.weather[0].main.toLowerCase();
    const locationName = weatherData.name;
    const countryCode = weatherData.sys.country;
    const { lat, lon } = weatherData.coord;

    // Choix de l'icône en fonction de la condition météo
    let WeatherIcon = Sun;
    if (condition.includes("cloud")) {
        WeatherIcon = Cloud;
    } else if (condition.includes("rain")) {
        WeatherIcon = CloudRain;
    }

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
        >
            <div className="flex flex-col items-center">
                <Card className="w-full p-4 bg-white rounded-lg dark:bg-zinc-900">
                    <div className="flex flex-col items-center">
                        <WeatherIcon className="w-16 h-16 text-yellow-500"/>
                        <h1 className="mt-4 text-3xl font-bold">{temperature}°C</h1>
                        <p className="mt-2 text-gray-600 capitalize">{weatherDescription}</p>
                        <p className="mt-2 text-gray-500">
                            {locationName}, {countryCode}
                        </p>
                        <p className="text-sm text-gray-400">
                            Coord: {lat.toFixed(2)}, {lon.toFixed(2)}
                        </p>
                    </div>
                </Card>

            </div>
        </motion.div>
    );
};

export default WeatherCard;
